import toFormat from "./toFormat";

export default function toYYYYMMDD(x: Date) {
  return toFormat(x, 'yyyy-MM-dd');
}
